/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import AIStateLoading from './ai-state-loading';
import AIStateDone from './ai-state-done';
import AIStateError from './ai-state-error';
var AIStateIndicator = function AIStateIndicator(_ref) {
  var state = _ref.state,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'ai-state-indicator' : _ref$testId,
    error = _ref.error;
  switch (state) {
    case 'error':
      return jsx(AIStateError, {
        appearance: appearance,
        testId: testId,
        error: error
      });
    case 'loading':
      return jsx(AIStateLoading, {
        appearance: appearance,
        testId: testId
      });
    case 'done':
      return jsx(AIStateDone, {
        appearance: appearance,
        testId: testId
      });
    default:
      return null;
  }
};
export default AIStateIndicator;